import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 28526 17556"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:413.421}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970275965888">
        <path
          d="M24015 8778c0 631-512 1144-1144 1144-631 0-1143-513-1143-1144 0-632 512-1144 1143-1144 632 0 1144 512 1144 1144zM19710 8778c0 631-512 1144-1143 1144s-1144-513-1144-1144c0-632 512-1144 1144-1144 631 1 1143 512 1143 1144zM15406 8778c0 631-512 1144-1143 1144-632 0-1144-513-1144-1144 0-632 512-1144 1144-1144s1143 512 1143 1144zM28319 8778c0 631-512 1144-1143 1144-632 0-1144-513-1144-1144 0-632 512-1144 1144-1144 631 1 1143 512 1143 1144z"
          className="fill stroke1"
          style={{
            strokeWidth: 413.421,
          }}
        />
      </g>
      <g id="_1970275965280">
        <path
          d="M11102 1351c0 631-512 1143-1143 1143-632 0-1144-512-1144-1143 0-632 512-1144 1144-1144 631 0 1143 512 1143 1144zM11102 5064c0 631-512 1144-1143 1144-632 0-1144-513-1144-1144s512-1143 1144-1143c631 0 1143 512 1143 1143zM6798 5064c0 631-512 1144-1144 1144-631 0-1143-513-1143-1144s512-1143 1143-1143c632 0 1144 512 1144 1143zM11102 8778c0 631-512 1144-1143 1144-632 0-1144-513-1144-1144 0-632 512-1144 1144-1144 631 1 1143 512 1143 1144zM6798 8778c0 631-512 1144-1144 1144-631 0-1143-513-1143-1144 0-632 512-1144 1143-1144 632 1 1144 512 1144 1144zM2494 8778c0 631-512 1144-1144 1144-631 0-1143-513-1143-1144 0-632 512-1144 1143-1144 632 1 1144 512 1144 1144zM11102 12492c0 631-512 1144-1143 1144-632 0-1144-512-1144-1144 0-631 512-1144 1144-1144 631 0 1143 512 1143 1144zM6798 12492c0 631-512 1144-1144 1144-631 0-1143-512-1143-1144 0-631 512-1144 1143-1144 632 0 1144 512 1144 1144zM11102 16206c0 631-512 1143-1143 1143-632 0-1144-512-1144-1143 0-632 512-1144 1144-1144 631 0 1143 512 1143 1144z"
          className="fill stroke1"
          style={{
            strokeWidth: 413.421,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
